var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlipIconLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6745 8.50281C12.6745 3.92018 7.22884 1.69635 3.96941 4.97674L3.20593 4.21815C7.12682 0.272048 13.7508 2.93764 13.7508 8.50281L12.6745 8.50281Z",
    fill: "#D7D7D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2375 10.6914L11.5927 8.45917L14.8823 8.45917L13.2375 10.6914Z",
    fill: "#D7D7D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07596 6.28564L3.72077 8.45914H0.431152L2.07596 6.28564Z",
    fill: "#D7D7D7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.60663 8.46385C2.61195 13.0465 8.06021 15.264 11.3158 11.9798L12.0802 12.7375C8.16388 16.6882 1.53682 14.0303 1.53035 8.4651L2.60663 8.46385Z",
    fill: "#D7D7D7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipIconLight);
export default __webpack_public_path__ + "static/media/flip-icon-light.afa6b375e7fc3fdd30706438849114b0.svg";
export { ForwardRef as ReactComponent };